import EnvironmentBadge from "@/components/EnvironmentBadge";

function BrandMark() {
  return (
    <div className="flex items-center gap-3">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-amber-600 text-2xl text-white shadow-sm" aria-hidden="true">🐝</div>
      <div>
        <div className="font-display text-2xl font-bold tracking-tight text-zinc-950">Bijen App</div>
        <div className="text-sm text-zinc-500 -mt-1">Bijenkastbeheer</div>
      </div>
    </div>
  );
}

export default function AuthFrame({ title, subtitle, heroTitle, heroText, children, footer }) {
  return (
    <div className="min-h-dvh bg-white md:grid md:grid-cols-[minmax(0,1fr)_minmax(420px,0.78fr)]">
      <section className="relative hidden md:flex min-h-screen overflow-hidden bg-zinc-950">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_22%,rgba(245,158,11,0.32),transparent_28%),radial-gradient(circle_at_78%_68%,rgba(217,119,6,0.25),transparent_32%),linear-gradient(135deg,#09090b_0%,#27272a_52%,#451a03_100%)]" aria-hidden="true" />
        <div className="absolute inset-0 opacity-20 bg-[linear-gradient(30deg,transparent_24%,rgba(255,255,255,0.16)_25%,rgba(255,255,255,0.16)_26%,transparent_27%,transparent_74%,rgba(255,255,255,0.12)_75%,rgba(255,255,255,0.12)_76%,transparent_77%)] bg-[length:72px_124px]" aria-hidden="true" />
        <div className="relative z-10 mt-auto p-10 lg:p-12 text-white max-w-xl">
          <div className="flex items-center gap-2 mb-4">
            <span className="text-xl" aria-hidden="true">🐝</span>
            <span className="text-sm font-semibold tracking-wide uppercase">Bijen App</span>
          </div>
          <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tight leading-tight">{heroTitle}</h1>
          <p className="mt-4 text-white/80 text-base leading-relaxed max-w-md">{heroText}</p>
        </div>
      </section>

      <main className="min-h-dvh flex flex-col px-5 pt-[calc(env(safe-area-inset-top,0)+32px)] pb-[calc(env(safe-area-inset-bottom,0)+24px)] md:justify-center md:px-12 md:py-12">
        <div className="w-full max-w-sm mx-auto">
          <BrandMark />
          <div className="mt-10">
            <h1 className="font-display text-4xl font-bold tracking-tight text-zinc-950">{title}</h1>
            <p className="mt-2 text-base leading-relaxed text-zinc-500">{subtitle}</p>
          </div>
          <div className="mt-7">{children}</div>
          {footer && <div className="mt-7 text-center text-sm text-zinc-600">{footer}</div>}
          <EnvironmentBadge />
        </div>
      </main>
    </div>
  );
}
